import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaymentTerm } from '../models/payment-term.model';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentTermService {

  constructor(private httpClient: HttpClient) { }

  getPaymentTerms() : Observable<PaymentTerm[]> {
    return this.httpClient.get<PaymentTerm[]>('assets/components/payment-terms/payment-terms.json').pipe(
      map(data => data)
    );
  }
}
